// extracted by mini-css-extract-plugin
export default {"lessonStatusContainer":"LessonStatus_lessonStatusContainer__knYWe","imgContainer":"LessonStatus_imgContainer__h0xmr","bottom":"LessonStatus_bottom__KCTVD"};